export default "__VITE_ASSET__B4Pap3yb__"